// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".burger-social {\n  position: relative;\n  display: flex;\n  align-items: center;\n  margin: 0 -10px; }\n  .burger-social__item {\n    position: relative;\n    padding: 0 10px; }\n  .burger-social__link {\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: opacity .3s ease; }\n    .burger-social__link:hover {\n      opacity: .7; }\n", ""]);
// Exports
module.exports = exports;
